var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Model, Watch } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import LoadFailed from '@/views/Errors/LoadFailed';
import SelectFilter from '@/components/select-filter/SelectFilter';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { Subject } from '@/models/Subject';
import { UserLevel } from '@/models/UserLevel';
import { UserPeriod } from '@/models/UserPeriod';
import ErrorHandler from '@/support/ErrorHandler';
import { UserPreferences } from '@/models/UserPreferences';
import { excludeRoles } from '@/support/ExcludeRoles';
import AbstractUrl from '@/support/AbstractUrl';
import { isEmpty, isArray } from 'lodash';
import { RolesEnum } from '@/items/Roles';
import { DateTime } from 'luxon';
import ConfirmGeneratePlpDialog from '@/components/dialog/ConfirmGeneratePlpDialog/ConfirmGeneratePlpDialog.vue';
import { Generate } from '@/models/Generate';
let Levels = class Levels extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.subjects = null;
        this.userLevels = [];
        this.userPeriods = [];
        this.userPreferences = [];
        this.isLoading = true;
        this.isEditingLevel = false;
        this.isEditingSingle = false;
        this.isEditingAll = false;
        this.editing = {};
        this.isLoadingTopic = {};
        this.isUserRedoingLevel = false;
        this.selected = [];
        this.selectedLevel = { type: 'level', value: '' };
        this.selectedPeriod = { type: 'period', value: '' };
        this.selectedLevelClone = null;
        this.levelFilter = {};
        this.periodFilter = {};
        this.isDownloadingTopics = false;
        this.isShowingActiveTopics = false;
        this.syncTime = '';
        this.isShowingConfirmGeneratePlpDialog = false;
        this.generateModel = new Generate();
        this.generateTime = '';
        this.clearSelects = false;
    }
    get exclude() {
        return !excludeRoles[this.$store.state.version].scoolUsers.detail.periods.includes(this.$store.state.Auth.roles[0].id);
    }
    get isAuthorized() {
        const authorizedRoles = [
            RolesEnum.ADMIN,
            RolesEnum.TEACHER,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ];
        return ((this.user &&
            this.user.roles &&
            this.user.roles.some((role) => authorizedRoles.includes(role.id))) ||
            false);
    }
    get user() {
        return this.$store.state.Auth;
    }
    mounted() {
        if (this.$route.query && !isEmpty(this.$route.query)) {
            this.$nextTick(() => {
                this.preFillSelects(this.$route.query);
            });
        }
        if (this.student && this.student.level && this.student.level.id) {
            this.selectedLevel.value = this.student.level.id;
        }
        this.initialize();
    }
    transformLevelName(levelName) {
        return levelName.replace(/Niveau (\d+)/, 'Leerjaar $1').replace(/Groep (\d+)/, 'Leerjaar $1');
    }
    async initialize() {
        this.isLoading = true;
        this.userLevels = await this.fetchUserLevels();
        this.userPeriods = await this.fetchUserPeriods();
        this.userPreferences = await this.fetchUserPreferences();
        console.log('this.userPreferences: ', this.userPreferences);
        this.clearSelects = false;
        this.fetchSubjects();
    }
    onGeneratePlpButtonClick() {
        this.isShowingConfirmGeneratePlpDialog = true;
    }
    fetchSubjects() {
        const filter = this.getFilter();
        new Subject()
            .include(['level', 'period', 'children'])
            .limit(100)
            .filter(filter)
            .all()
            .then((subjects) => {
            this.subjects = subjects;
            this.buildEditingObject();
            this.isLoading = false;
        })
            .catch((error) => {
            this.isLoading = false;
        });
    }
    buildEditingObject() {
        if (!this.subjects) {
            return;
        }
        const editObject = {};
        this.subjects.forEach((subject) => {
            if (subject.children) {
                subject.children.forEach((child) => {
                    if (child.id) {
                        const periodId = this.getPeriodId(child.id);
                        const levelId = this.getLevelId(child.id);
                        const edit = {
                            editing: false,
                            period: {
                                value: periodId,
                                default: periodId,
                            },
                            level: {
                                value: levelId,
                                default: levelId,
                            },
                        };
                        editObject[child.id] = edit;
                    }
                });
            }
        });
        this.editing = editObject;
    }
    getFilter() {
        const filter = {};
        if (this.levelFilter.value) {
            filter.levels = this.levelFilter.value;
        }
        if (this.periodFilter.value) {
            filter.periods = this.periodFilter.value;
        }
        filter.current = true;
        return filter;
    }
    setSelected(area) {
        if (!area.children) {
            return;
        }
        area.children.forEach((subject) => {
            this.selected.push(subject);
        });
    }
    isExcluded(id) {
        const preferences = this.findUserPreference(id);
        return preferences ? preferences.state === 'excluded' : true;
    }
    isExcludedFromCurriculum(id) {
        const preferences = this.findUserPreference(id);
        return preferences ? !preferences.subject.is_idp_eligible : false;
    }
    updateSingleSubject(id) {
        if (!id) {
            return;
        }
        this.$set(this.isLoadingTopic, id, true);
        const subject = this.editing[id];
        subject.subjectId = id;
        const payload = {
            subject: subject.subjectId,
            level: subject.level.value,
            period: subject.period.value,
        };
        new UserPeriod()
            .updatePeriodLevel(this.student.id, payload)
            .then((userPeriod) => {
            const edit = {
                editing: false,
                period: {
                    value: userPeriod.period.id,
                    default: userPeriod.period.id,
                },
                level: {
                    value: userPeriod.level.id,
                    default: userPeriod.level.id,
                },
            };
            this.editing[subject.subjectId] = { ...edit, ...{} };
            this.editing[id].editing = false;
            setTimeout(() => {
                this.$set(this.isLoadingTopic, id, false);
                this.resetIsEditingSingle();
            }, 500);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    createUpdatePayload() {
        if (!this.subjects) {
            return;
        }
        const subjectsLevels = [];
        this.selected.forEach((subject) => {
            if (subject.depth === 1 && subject.id) {
                subjectsLevels.push({
                    id: subject.id,
                    level: this.selectedLevel.value,
                    period: this.selectedPeriod.value,
                });
            }
            else {
                if (!subject.children) {
                    return;
                }
                subject.children.forEach((child) => {
                    if (!child.id) {
                        return;
                    }
                    const item = {
                        id: child.id,
                        level: this.selectedLevel.value,
                        period: this.selectedPeriod.value,
                    };
                    subjectsLevels.push(item);
                });
            }
        });
        return subjectsLevels;
    }
    async updateUserLevel() {
        if (this.selectedLevel === null || this.selectedPeriod === null) {
            return;
        }
        const payload = this.createUpdatePayload();
        this.isLoading = true;
        const updateCallback = async (response) => {
            if (response) {
                await this.refresh();
            }
        };
        await new UserLevel()
            .user(this.student)
            .put({ subjects: payload })
            .then(updateCallback);
        await new UserPeriod()
            .user(this.student)
            .put({ subjects: payload })
            .then(updateCallback);
    }
    getLevelName(subjectId) {
        const level = this.userLevels.find((userLevel) => {
            return userLevel.subject && userLevel.subject.id === subjectId;
        });
        if (level && level.level) {
            return level.level.name;
        }
        return this.student.level ? this.student.level.name : '0';
    }
    getLevelId(subjectId) {
        const level = this.userLevels.find((userLevel) => {
            return userLevel.subject && userLevel.subject.id === subjectId;
        });
        if (level && level.level) {
            return level.level.id;
        }
        return this.student.level ? this.student.level.id : 0;
    }
    getPeriodName(subjectId) {
        if (!subjectId) {
            return;
        }
        const period = this.userPeriods.find((userPeriod) => {
            return userPeriod.subject && userPeriod.subject.id === subjectId;
        });
        if (period && period.period) {
            return `${this.$tc('period.title')} ${period.period.name}`;
        }
        else {
            return `${this.$tc('period.title')} ${this.$store.state.period.name}`;
        }
    }
    getPeriodId(subjectId) {
        if (!subjectId) {
            return;
        }
        const userPeriod = this.userPeriods.find((userPeriod) => {
            return userPeriod.subject && userPeriod.subject.id === subjectId;
        });
        if (userPeriod !== undefined && userPeriod.period !== undefined) {
            return userPeriod.period.id;
        }
        if (this.$store.state.period !== null) {
            return this.$store.state.period.id;
        }
        return '0';
    }
    getLevelAdjustment(userLevel) {
        const studentLevel = userLevel.level.value;
        const topicLevel = this.student.level.value;
        return studentLevel - topicLevel;
    }
    getPeriodAdjustment(subjectId) {
        const userPeriod = this.userPeriods.find((userPeriod) => {
            return userPeriod.subject && userPeriod.subject.id === subjectId;
        });
        if (!userPeriod) {
            return 0;
        }
        const periods = this.$store.state.year.periods;
        const currentIndex = periods.findIndex((period) => {
            return period.is_current;
        });
        const periodIndex = periods.findIndex((period) => {
            return period.id === userPeriod.period.id;
        });
        return periodIndex - currentIndex;
    }
    getAdjustment(subjectId) {
        const userPeriod = this.userPeriods.find((userPeriod) => {
            return userPeriod.subject && userPeriod.subject.id === subjectId;
        });
        return userPeriod && userPeriod.deviation ? userPeriod.deviation : 0;
    }
    refresh() {
        this.isEditingAll = false;
        this.isEditingLevel = false;
        this.selected = [];
        this.selectedLevel = { type: 'level', value: '' };
        this.selectedPeriod = { type: 'period', value: '' };
        this.clearSelects = true;
        this.initialize();
    }
    close() {
        this.isEditingLevel = false;
        this.selected = [];
    }
    preFillSelects(filters) {
        if (filters.levels && this.$refs.levelSelect) {
            this.$refs.levelSelect.setSelected(isArray(filters.levels) ? filters.levels : [filters.levels]);
        }
        if (filters.periods && this.$refs.periodSelect) {
            this.$refs.periodSelect.setSelected(isArray(filters.periods) ? filters.periods : [filters.periods]);
        }
        if (filters.active) {
            this.isShowingActiveTopics = filters.active === 'true';
        }
    }
    async fetchUserLevels() {
        return await new UserLevel().user(this.student).all();
    }
    async fetchUserPreferences() {
        return new UserPreferences().user(this.student).all();
    }
    async fetchUserPeriods() {
        return new UserPeriod().user(this.student).all();
    }
    updateStudent(event) {
        if (!(this.student && this.student.student)) {
            return;
        }
        const payload = {
            redo_current_level: this.student.student.redo_current_level || false,
            recalculate_deviation: this.student.student.recalculate_deviation || false,
        };
        if (!this.student.student.redo_current_level) {
            payload.recalculate_deviation = false;
        }
        this.student
            .include(['student', 'period'])
            .update({ student: payload })
            .then((student) => {
            if (!(this.student && this.student.student)) {
                return;
            }
            this.student.student.recalculate_deviation =
                (student.student && student.student.recalculate_deviation) || false;
            this.student.student.redo_current_level =
                (student.student && student.student.redo_current_level) || false;
        })
            .catch((error) => ErrorHandler.network(error));
    }
    async downloadAllTopics() {
        this.isDownloadingTopics = true;
        const response = await this.student.downloadReport();
        if (response && response.url) {
            window.open(response.url);
        }
        this.isDownloadingTopics = false;
    }
    getQueryParams() {
        let filters = this.getFilter();
        filters = { ...filters, ...{ active: this.isShowingActiveTopics } };
        return filters;
    }
    navigateToCurricula(url) {
        return this.$router.push(url);
    }
    updateSubjectState(id, state) {
        if (!this.$store.state.Auth.hasRole([
            RolesEnum.TEACHER,
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
        ])) {
            return;
        }
        this.updateSubject(state, id);
    }
    updateSubject(state, id) {
        this.$set(this.isLoadingTopic, id, true);
        new UserPreferences()
            .user(this.student)
            .create({
            subject: id,
            state,
        })
            .then((userPreferences) => {
            this.userPreferences = this.userPreferences.filter((userPreferencesItem) => {
                return ((userPreferencesItem.subject && userPreferencesItem.subject.id) !==
                    (userPreferences && userPreferences.subject.id));
            });
            this.userPreferences.push(userPreferences);
            setTimeout(() => {
                this.$set(this.isLoadingTopic, id, false);
            }, 500);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    isHidingExcludedTopic(id, subject) {
        if (subject) {
            return (this.isShowingActiveTopics && (this.isExcluded(id) || this.hasAllExcludedChildren(subject)));
        }
        return this.isShowingActiveTopics && this.isExcluded(id);
    }
    hasAllExcludedChildren(subject) {
        let count = 0;
        if (subject && subject.children) {
            subject.children.forEach((child) => {
                count += this.isExcluded(child.id || '') ? 1 : 0;
            });
        }
        return subject && subject.children && count === subject.children.length;
    }
    hasSubjectChildren(hasChildren) {
        return this.isShowingActiveTopics && !hasChildren;
    }
    findUserPreference(id) {
        return this.userPreferences.find((userPreferences) => {
            if (!userPreferences.subject) {
                return false;
            }
            return userPreferences.subject === id || userPreferences.subject.id === id;
        });
    }
    resetIsEditingSingle() {
        let count = 0;
        Object.keys(this.editing).forEach((id) => {
            if (this.editing[id].editing) {
                count += 1;
            }
        });
        this.isEditingSingle = count > 0 ? true : false;
    }
    removeUserPeriod(userPeriod) {
        return this.userPeriods.filter((currentUserPeriod) => {
            return (currentUserPeriod.subject.id !== userPeriod.subject.id ||
                currentUserPeriod.period.id !== userPeriod.period.id);
        });
    }
    updateAllUserLevels() {
        if (this.selectedLevel === null) {
            return;
        }
        this.student
            .include(['chat', 'level', 'relationships', 'student', 'period', 'token'])
            .update({
            student: {
                level: this.selectedLevel.value,
                period: this.selectedPeriod.value,
            },
        })
            .then((student) => {
            this.$emit('update', student);
            if (student && student.level && student.level.id) {
                this.selectedLevel.value = student.level.id;
            }
            this.refresh();
        });
    }
    get levelItems() {
        return this.$store.state.filters.Level.map((level) => {
            level.text = this.transformLevelName(level.text);
            return level;
        });
    }
    get syncDisabled() {
        if (this.syncTime.length === 0) {
            return false;
        }
        const syncStart = DateTime.fromISO(this.syncTime);
        const now = DateTime.local();
        if (now.diff(syncStart, 'minutes').as('minutes') > 5) {
            return false;
        }
        return true;
    }
    generate() {
        this.generateModel
            .create({
            users: [this.student.id],
        })
            .then((response) => {
            this.syncTime = DateTime.local().toString();
        })
            .catch((error) => {
            if (!this.generateTime.length) {
                this.syncTime = DateTime.local().toString();
            }
            ErrorHandler.network(error);
        });
    }
    get studentName() {
        return this.student.name || '';
    }
    isShowingActiveTopicsChanged() {
        const filters = this.getQueryParams();
        this.setQueryParams(filters);
    }
    levelFilterChanged(newValue) {
        const filters = this.getQueryParams();
        this.setQueryParams(filters);
        this.fetchSubjects();
    }
    periodFilterChanged(newValue) {
        const filters = this.getQueryParams();
        this.setQueryParams(filters);
        this.fetchSubjects();
    }
    resetIsEditingAll() {
        this.isEditingAll = false;
        this.selectedLevel = this.selectedLevelClone;
        this.selected = [];
        this.selectedLevelClone = null;
    }
    isEditingAllChanged() {
        if (this.isEditingAll) {
            this.selectedLevelClone = { ...this.selectedLevel, ...{} };
        }
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Levels.prototype, "student", void 0);
__decorate([
    Watch('isShowingActiveTopics'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Levels.prototype, "isShowingActiveTopicsChanged", null);
__decorate([
    Watch('levelFilter.value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Levels.prototype, "levelFilterChanged", null);
__decorate([
    Watch('periodFilter.value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Levels.prototype, "periodFilterChanged", null);
__decorate([
    Watch('isEditingAll'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Levels.prototype, "isEditingAllChanged", null);
Levels = __decorate([
    Component({
        components: {
            LoadFailed,
            LoaderCard,
            SelectFilter,
            ConfirmGeneratePlpDialog,
        },
    })
], Levels);
export default Levels;
